/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ApiPersonDetailReviewsListServiceTypeCategory =
  (typeof ApiPersonDetailReviewsListServiceTypeCategory)[keyof typeof ApiPersonDetailReviewsListServiceTypeCategory];

export const ApiPersonDetailReviewsListServiceTypeCategory = {
  'core-services': 'core-services',
  'dog-training': 'dog-training',
  'all-services': 'all-services',
} as const;
